import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';

export const aiAboutCardModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [
    catalogPlugin.getExtension('entity-card:catalog/about').override({
      factory(originalFactory) {
        return originalFactory({
          params: {
            loader: async () =>
              import('../components').then(m => <m.EssityEntityAboutCard />),
          },
        });
      },
    }),
  ],
});
